__turbopack_context__.v({
  "image": "PdfPage-module__FV745W__image",
  "pageContainer": "PdfPage-module__FV745W__pageContainer",
  "removedImage": "PdfPage-module__FV745W__removedImage",
  "selectedImage": "PdfPage-module__FV745W__selectedImage",
});
